import { Checklist } from "models/checklist";
import { Extra } from "models/extra";
import { FollowUp } from "models/followUp";
import { Times } from "models/travelTimes";
import { UsedPart } from "models/usedPart";
import { FileType, MeterReadingInputType } from "operations/schema/schema";

export const JobVisitsStorageKey = "jobVisits";
export const PartnerJobVisitsStorageKey = "partnerJobVisits";

export type JobVisitType = {
  actionId1: string;
  actionId2?: string;
  actionId3?: string;
  autoEndTime: boolean;
  changeServiceTerms: boolean;
  checklists: Checklist[];
  customerSignerName: string;
  errors: any;
  signoffErrors: any;
  extras: Extra[];
  files: FileType[];
  followUp: FollowUp;
  meterReadings?: MeterReadingInputType[];
  serviceReportEmail: string | null;
  signatureCustomer: string | undefined;
  signatureEngineer: string | undefined;
  skipSignature: boolean;
  solutionDescription: string;
  travelTimes: Times[];
  travelTimesInvoiceType: string | null;
  usedParts: UsedPart[];
  workTimes: Times[];
  workTimesInvoiceType: string | null;
  submitLoading: boolean;
  metersNotSaved: boolean;
  metersUseCurrent: boolean;
  reference: string;
  customerSatisfaction?: number;
};
